import dayjs from 'dayjs';

import { BetEventModel } from '@shared/types';

import { BetEventFormValues } from '../../../BetSystemSettingsForms';

export const getBetEventFormValuesFromModel = (betEvent: BetEventModel) => {
  const { id, imageId, startDate, ...restFields } = betEvent;

  const formValues: BetEventFormValues = {
    ...restFields,
    startDate: dayjs(startDate),
    imageId,
  };

  return formValues;
};
